/**
 * @fileoverview Utility function for formatting durations into localized time strings.
 * Converts millisecond durations into formatted JSX elements displaying time in "hh:mm:ss" format.
 *
 * @example
 * // Basic usage
 * formatDuration(65000) // renders <span>01:05:00</span>
 *
 * @example
 * // With different locale
 * formatDuration(65000, 'en-US') // renders <span>01:05:00</span>
 *
 * @example
 * // With undefined duration
 * formatDuration(undefined) // renders <span className="text-gray-400">n/a</span>
 */


/**
 * Format duration from ms to the local "hh:mm:ss"-like string
 * @param duration number
 * @param format string
 * @returns string
 */
export function formatDuration(duration: number, format = 'en-GB'): JSX.Element {
    if (duration === undefined) {
        return <span className="text-gray-400">n/a</span>
    }

    const dateFormatter = new Intl.DateTimeFormat(format, {
        timeZone: 'Etc/UTC',
        hour12: false,
        minute: '2-digit',
        second: '2-digit',
    })

    const time = dateFormatter.format(new Date(duration * 1000))
    return <span>{time}</span>
}
